// extracted by mini-css-extract-plugin
module.exports = {"filterparam":"styles_filterparam__XF-_r","title":"styles_title__1d-lq"};